module.exports = __webpack_public_path__ + "img/xmark.bc35881b.svg";